import { type ReactNode } from 'react';

import { api } from 'common';

import { BlockSwitchField } from './Switch';
import { type ConfigFieldProps } from './types';

interface FieldProps extends ConfigFieldProps {
  label: ReactNode;
  helperText?: ReactNode;
}

export function BlockRunModeField(props: FieldProps) {
  const { fieldName, label = 'Value', helperText } = props;
  return (
    <BlockSwitchField
      label={label}
      fieldName={fieldName}
      helperText={helperText}
      toggleStates={{
        activeState: api.FlowDefinition.RunMode.Test,
        inactiveState: api.FlowDefinition.RunMode.Live,
      }}
    />
  );
}
